import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import {
  selectOrderState,
  setSearchFilter,
} from "../../../store/order/orderFilterSlice";
import classes from "./orderFilterPage.module.css";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";

export const OrderFilterPage = () => {
  const filters = useSelector(selectOrderState);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const searchParam = searchParams.get("search") || null;

    if (filters.search !== searchParam) {
      dispatch(setSearchFilter(searchParam));
    }
  }, [searchParams, dispatch, filters]);

  const updateFilter = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);

    if (value) newSearchParams.set(key, value);
    else newSearchParams.delete(key);

    setSearchParams(newSearchParams);

    if (key === "search") dispatch(setSearchFilter(value));
  };

  const handleSearch = (text) => updateFilter("search", text);
  const handleClearSearch = () => updateFilter("search", null);

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          onSearch={handleSearch}
          searchTextFrmStore={filters.search}
          searchFilter={!!filters.search}
          onClear={handleClearSearch}
        />
      </div>
    </div>
  );
};
